export default __webpack_public_path__ + "static/media/List_Example_PLN.e223a639.png";